<section mat-dialog-content>
    <div>{{msg}}</div>
</section>